<template>
  <li :class="{ group: model.agents.length }">
    <span class="line"></span>
    <span class="item">
      <span
          @click="toggle"
          :class="[model.agents.length ? 'cursor-pointer' : '', head ? 'text-primary' : '']">
        <template v-if="head">
          <i class="ki-outline fs-4 ki-award cursor-help" title="Начальник" :class="model.agents.length ? 'text-primary' : ''"></i>
        </template>
        <template v-else-if="model.person === 0">
          <i class="ki-outline fs-4 ki-people cursor-help" title="Агент (Юр. лицо)" :class="model.agents.length ? 'text-primary' : ''"></i>
        </template>
        <template v-else>
          <i class="ki-outline fs-4 cursor-help" :title="userData[model.role].title" :class="[model.agents.length ? 'text-primary' : '', userData[model.role].icon]"></i>
        </template>
        {{ model.title }}
        <span v-if="model.agents.length" class="arrow m-1" :class="{ active: isOpen }">
          <span></span>
          <span></span>
        </span>
      </span>
    </span>
    <ul class="employees__list" v-show="isOpen" v-if="model.agents.length">
      <branch-users-item
          v-for="(model, index) in model.agents"
          :key="index"
          :model="model">
      </branch-users-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'BranchUsersItem',
  props: {
    model: Object,
    head: false,
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      userData: {
        0: {title: 'Администратор',   icon: 'ki-shield'},
        1: {title: 'Модератор',       icon: 'ki-security-user'},
        2: {title: 'Бухгалтер',       icon: 'ki-chart-pie-simple'},
        3: {title: 'Менеджер',        icon: 'ki-profile-user'},
        4: {title: 'Агент',           icon: 'ki-profile-circle'},
        5: {title: 'Суб-Агент',       icon: 'ki-user'},
        6: {title: 'ДРМ ПОДФТ',       icon: 'ki-shield-search'},
        7: {title: 'Сервис менеджер', icon: 'ki-shield-tick'},
        8: {title: 'Резерв',          icon: 'ki-rescue'},
      }
    }
  },
  mounted() {
    this.isOpen = this.open
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped>
.item > .employee__btn-group {
  top: 2px;
}
.employee__tree-add i {
  color: #2196F3;
  opacity: .6;
}
.employee__tree-add_user i {
  border-right: 1px solid #cccccc;
  padding-right: 5px;
  color: #2196F3;
  opacity: .6;
}
.employee__tree-edit i {
  color: #FF9800;
  opacity: .6;
}
.employee__tree-add_user:hover i,
.employee__tree-add:hover i {
  opacity: 1;
}
.employee__tree-edit:hover i {
  opacity: 1;
}
</style>